import React from 'react'
import { withTranslation, Trans } from 'react-i18next'

import HelloBlock from './HelloBlock'
import WhatIsBlock from './WhatIsBlock'
import UnlockBlock from './UnlockBlock'
import WhoCanBlock from './WhoCanBlock'
import PlatformsBlock from './PlatformsBlock'
import StepsBlock from './StepsBlock'
import MobileBlock from './MobileBlock'
import IntegrationsBlock from './IntegrationsBlock'

// import UsedBlock from '../../components/Used'
import MechanicsBlock from '../../components/Mechanics'
import TemplatesBlock from '../../components/Templates'
import RegistrationBlock from '../../components/Registration'

const HomeNew = ({ t }) => {
    // const [offsetTopValue, setOffsetTopValue] = useState(0)
    //
    // useEffect(() => {
    //     const onScroll = () => {
    //         const offsetTop = window.pageYOffset
    //         setOffsetTopValue(offsetTop)
    //     }
    //     window.addEventListener('scroll', onScroll)
    //     return () => window.removeEventListener('scroll', onScroll)
    // }, [])

    return (
        <div className="home-new-page-container">
            <HelloBlock />
            {/*<UsedBlock additionalClass="__home" />*/}
            <WhatIsBlock />
            <UnlockBlock />
            <MechanicsBlock
                additionalClass="__home"
                fontColor={'#000000'}
                title={t('_pages._home._mechanics_block.title')}
                subtitle={<Trans i18nKey="_pages._home._mechanics_block.subtitle" />}
            />
            <WhoCanBlock />
            <PlatformsBlock />
            <StepsBlock />
            <MobileBlock />
            <TemplatesBlock
                additionalClass="__home"
                title={t('_pages._home._templates_block.title')}
                subtitle={<Trans i18nKey="_pages._home._templates_block.subtitle" />}
                showType={true}
                customId={null}
                topOffsetRequest={'-500'}
            />
            <IntegrationsBlock />
            <RegistrationBlock />
        </div>
    )
}

export default withTranslation('translations')(HomeNew)
